var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { electron } from 'lib-shared-electron';
import analytics from 'lib-shared-segment';
import { getHighestUserRole } from 'lib-shared-user-role';
import { loadSegment } from './script';
function getDesktopAppVersion() {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        if (!electron.isElectron()) {
            return null;
        }
        const version = yield ((_a = window.electron) === null || _a === void 0 ? void 0 : _a.getVersion());
        return version || null;
    });
}
function identify(payload) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { analytics } = window;
        const { user, organization } = payload;
        if (!analytics || !user || !organization) {
            return;
        }
        const groupTraits = {
            organization_id: organization.id,
            name: organization.name,
            avatar: organization.avatar_url,
            subdomain: organization.subdomain,
            website: location.origin,
            created_at: organization.created_at,
            trial_ended_at: organization.trial_ended_at,
            suspended: organization.suspended,
        };
        const userTraits = Object.assign({ name: user.name, email: user.email, avatar: user.avatar_url, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            role: getHighestUserRole(((_a = user.roles) !== null && _a !== void 0 ? _a : ['agent'])), phone: user.phone_number, bundleTimestamp: TIMESTAMP.trim(), bundleVersion: VERSION.trim() }, (electron.isElectron() && {
            desktopAppVersion: yield getDesktopAppVersion(),
        }));
        analytics.identify(user.id, userTraits);
        analytics.group(organization.id, groupTraits);
    });
}
function initSegment(payload) {
    return __awaiter(this, void 0, void 0, function* () {
        if (payload.organization.id === '980811c9-72ee-41df-8167-8cb0686072bc') {
            // We don't load segment on Test orgs. in order to not pollute BI data.
            return;
        }
        loadSegment(() => identify(payload));
    });
}
export { analytics, initSegment };
